import React, { Component } from 'react';
import { Table, Input, Button, Icon } from 'antd';

let state = {
    filterDropdownVisible: false,
    trips: [],
    searchText: '',
    filtered: false
};

const Search = Input.Search;

class TripsTable extends Component {
    constructor() {
        super();
        this.state = state;
        this.onInputChange = this.onInputChange.bind(this);
        this.onSearch = this.onSearch.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        // if (typeof nextProps.trips !== "undefined" && nextProps.trips !== null && nextProps.trips.length !== 0) {
            this.setState({ trips: nextProps.trips });
        // }
    }

    onInputChange(e) {
        this.setState({ searchText: e.target.value });
    }

    onSearch() {
        const { searchText } = this.state;
        const reg = new RegExp(searchText, 'gi');
        this.setState({
            filterDropdownVisible: false,
            filtered: !!searchText,
            trips: this.state.trips.map((record) => {
                const match = record.name.match(reg);
                if (!match) {
                    return null;
                }
                return {
                    ...record,
                    name: (
                        <span>
                            {record.name.split(reg).map((text, i) => (
                                i > 0 ? [<span className="highlight">{match[0]}</span>, text] : text
                            ))}
                        </span>
                    ),
                };
            }).filter(record => !!record),
        });
    }

    render() {
        const columns = [{
            title: 'Trip Id',
            dataIndex: 'trip_id',
            key: 'trip_id',
            /* filterDropdown: (
                <div className="custom-filter-dropdown" style={{float: "left"}}>
                    <Search
                        ref={ele => this.searchInput = ele}
                        placeholder="Search Trip"
                        value={this.state.searchText}
                        onChange={this.onInputChange}
                        onPressEnter={this.onSearch}
                        size="small"
                        style={{ width: 100 }}
                        onSearch={value => console.log(value)}
                        enterButton
                    />
                </div>
            ),
            filterIcon: <Icon type="search" style={{ color: this.state.filtered ? '#108ee9' : '#aaa' }} />,
            filterDropdownVisible: this.state.filterDropdownVisible,
            onFilterDropdownVisibleChange: (visible) => {
                this.setState({
                    filterDropdownVisible: visible,
                }, () => this.searchInput && this.searchInput.focus());
            }, */
        }, {
            title: 'Start',
            dataIndex: 'pu_time',
            key: 'pu_time',
            render: (text, record) => (
                <div>{this.convertMinutesToAmPm(text)}</div>
              ),
            /* filters: [{
                text: 'AM',
                value: 'am',
            }, {
                text: 'PM',
                value: 'pm',
            }],
            onFilter: (value, record) => record.address.indexOf(value) === 0, */
        }, {
            title: 'End',
            dataIndex: 'do_time',
            key: 'do_time',
            render: (text, record) => (
                <div>{this.convertMinutesToAmPm(text)}</div>
              ),
            /* filters: [{
                text: 'AM',
                value: 'am',
            }, {
                text: 'PM',
                value: 'pm',
            }],
            onFilter: (value, record) => record.address.indexOf(value) === 0, */
        }];
        return <Table columns={columns} dataSource={this.state.trips} scroll={{ y: 330 }} pagination={false} size="small" />;
    }

    convertMinutesToAmPm(theMins) {
        let aIsAm = true;
        if (theMins >= 12 * 60) {
            aIsAm = false;
        }
        let aHr = 0, aMin = 0;
        let aHrStr = "", aMinStr = "";
        if (aIsAm) {
            if (aIsAm === 0) {
                return "0000A";
            }
            aHr = Math.floor(theMins / 60);
            aMin = theMins % 60;
            if (aHr < 10) {
                aHrStr = "0" + aHr.toString();
            } else {
                aHrStr = aHr.toString();
            }
            if (aMin < 10) {
                aMinStr = "0" + aMin.toString();
            } else {
                aMinStr = aMin.toString();
            }
            return aHrStr + aMinStr + "A";
        } else {
            if (theMins === 12 * 60) {
                return "1200P";
            }
            aHr = Math.floor((theMins - 12 * 60) / 60);
            aMin = (theMins - 12 * 60) % 60;
            if (aHr < 10) {
                if (aHr === 0) {
                    aHrStr = "12";
                } else {
                    aHrStr = "0" + aHr.toString();
                }
            } else {
                aHrStr = aHr.toString();
            }
            if (aMin < 10) {
                aMinStr = "0" + aMin.toString();
            } else {
                aMinStr = aMin.toString();
            }
            return aHrStr + aMinStr + "P";
        }
      }
}

export default TripsTable;



// WEBPACK FOOTER //
// ./src/Componets/TripsTable.js